export const normalizeInputValue = value => value?.trim() ?? ''

export const normalizeNumericValue = (value) => {
  if (value === null || value === undefined || value === '') return null

  const numericValue = Number(value)

  if (Number.isNaN(numericValue)) return null

  return numericValue
}

export const roundCurrency = value => Math.round((value + Number.EPSILON) * 100) / 100
